import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, ExcludedContentOperationType, HelpIndex } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { NameDescriptionComponent } from '../../name-description/name-description.component';
import { DrObjectType, DrObject } from '../../../models/dr-object';

@Component({
    standalone: false,
    selector: 'res-excluded-content-modal',
    templateUrl: './excluded-content-modal.component.html',
    styleUrls: ['./excluded-content-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ExcludedContentModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(NameDescriptionComponent, { static: true }) nameDescriptionComponent: NameDescriptionComponent;
    validateNameRequest = {
        endpoint: Endpoint.viewManager_validateName,
        request: () => {
            return {
                name: this.nameDescriptionComponent.name,
                objectType: DrObjectType.EXCLUDED_CONTENT,
                projectHandle: this.modalData.currentHandle ? this.modalData.currentHandle : this.commonService.currentProject.handle,
                systemScope: this.modalData?.systemScope
            };
        }
    };

    modalTitle = '';
    modalAutomationId = 'excluded-content-block-template';
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    verifyRequiredValidator = true;
    isBusy = false;
    isBusyMessage = '';
    modalHelpIndex = HelpIndex.add_edit_email_signature_dlg;
    modalClass = 'excluded-content-block-modal';
    handle = '';
    blockContent = '';
    originalBlockContent: string;
    validateName = true;
    tooltipName = 'An Excluded Content Block name is limited to 32 characters.';

    excludedContentTypes = {
        new_excluded_content_block: {
            title: ' New Excluded Content Block',
            isBusyMessage: 'Creating a new Excluded Content Block',
            endPoint: Endpoint.projectManager_createEmailSignature
        },
        edit_excluded_content_block: {
            title: 'Edit Excluded Content Block',
            isBusyMessage: 'Editing Excluded Content Block',
            endPoint: Endpoint.projectManager_updateEmailSignature
        },
        duplicate_excluded_content_block: {
            title: 'Duplicate Excluded Content Block',
            isBusyMessage: 'Duplicating Excluded Content Block',
            endPoint: Endpoint.projectManager_createEmailSignature
        }
    };
    currentExcludedBlock: any;

    operationType: ExcludedContentOperationType;

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private cdRef: ChangeDetectorRef
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.nameDescriptionComponent.drObject = new DrObject(DrObjectType.EXCLUDED_CONTENT);
        this.nameDescriptionComponent.drObject.maxNameLength = 32;

        this.operationType = <ExcludedContentOperationType>this.modalData.operationType;

        this.currentExcludedBlock = _.pick(this.excludedContentTypes, this.operationType);
        this.modalTitle = this.currentExcludedBlock[Object.keys(this.currentExcludedBlock)[0]].title;

        if (this.operationType === ExcludedContentOperationType.edit_excluded_content_block) {
            this.nameDescriptionComponent.name = this.modalData.data.name;
            this.nameDescriptionComponent.description = this.modalData.data.description;
            this.blockContent = this.originalBlockContent = this.modalData.data.emailSignatureText;
        }

        if (this.operationType === ExcludedContentOperationType.duplicate_excluded_content_block) {
            this.nameDescriptionComponent.description = this.modalData.data.description;
            this.blockContent = this.originalBlockContent = this.modalData.data.emailSignatureText;
        }

        this.cdRef.detectChanges();
    }

    OK(): void {
        const request = {
            name: this.nameDescriptionComponent.name,
            description: this.nameDescriptionComponent.description,
            emailSignatureText: this.blockContent,
            systemScope: this.modalData?.systemScope
        };

        this.isBusy = true;
        this.isBusyMessage = this.currentExcludedBlock[Object.keys(this.currentExcludedBlock)[0]].isBusyMessage;

        if (this.currentExcludedBlock[Object.keys(this.currentExcludedBlock)[0]].title === 'Edit Excluded Content Block') {
            request['emailSignatureHandle'] = this.modalData.data.handle;
        } else {
            request['ownerHandle'] = this.modalData.currentHandle;
        }

        // make api call based on the pattern operation
        this.restService.post(this.currentExcludedBlock[Object.keys(this.currentExcludedBlock)[0]].endPoint,
            request,
            false
        ).then(() => {
            this.isBusy = false;
            this.closeModal(true);
        }, () => {
            this.isBusy = false;
        });

    }

    isExcludedContentComplete(): boolean {
        let isComplete = false;
        if (!DrObject.isEmpty(this.blockContent)) {
            isComplete = true;
        }
        return isComplete;
    }

    isPrimaryButtonEnabled(): boolean {
        let enabled = false;
        if (!this.isBusy) {
            if (!DrObject.isEmpty(this.nameDescriptionComponent.name)) {
                if (this.nameDescriptionComponent.isNameDirty() && (this.nameDescriptionComponent.formValid) && this.isExcludedContentComplete()) {
                    enabled = true;
                } else if ((this.nameDescriptionComponent.isDescriptionDirty()) && (this.nameDescriptionComponent.formValid) && this.isExcludedContentComplete()) {
                    enabled = true;
                } else if (!this.nameDescriptionComponent.isDescriptionDirty() && !this.nameDescriptionComponent.isNameDirty() &&
                    this.isExcludedContentComplete() && DrObject.isValueDirty(this.blockContent, this.originalBlockContent)) {
                    enabled = true;
                }
            }
        }
        return enabled;
    }
}
